module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('gs-header', {
    attrs: {
      "title": "Cấu hình cài đặt"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "padding-all"
  }, [_c('el-form', {
    ref: "updateSettingForm",
    attrs: {
      "model": _vm.localSetting,
      "rules": _vm.rules,
      "label-width": "200px",
      "label-position": "top"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateBeforeSubmitRegion('updateSettingForm')
      }
    }
  }, [_c('el-row', {
    staticClass: "remove-margin",
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tên",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Tên"
    },
    model: {
      value: (_vm.localSetting.name),
      callback: function($$v) {
        _vm.$set(_vm.localSetting, "name", $$v)
      },
      expression: "localSetting.name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Địa chỉ",
      "prop": "address"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Địa chỉ"
    },
    model: {
      value: (_vm.localSetting.address),
      callback: function($$v) {
        _vm.$set(_vm.localSetting, "address", $$v)
      },
      expression: "localSetting.address"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Tiêu đề seo",
      "prop": "meta_title"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Tiêu đề seo"
    },
    model: {
      value: (_vm.localSetting.meta_title),
      callback: function($$v) {
        _vm.$set(_vm.localSetting, "meta_title", $$v)
      },
      expression: "localSetting.meta_title"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Từ khóa seo",
      "prop": "meta_keyword"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "Từ khóa seo"
    },
    model: {
      value: (_vm.localSetting.meta_keyword),
      callback: function($$v) {
        _vm.$set(_vm.localSetting, "meta_keyword", $$v)
      },
      expression: "localSetting.meta_keyword"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Mô tả seo",
      "prop": "meta_description"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "Mô tả seo"
    },
    model: {
      value: (_vm.localSetting.meta_description),
      callback: function($$v) {
        _vm.$set(_vm.localSetting, "meta_description", $$v)
      },
      expression: "localSetting.meta_description"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Mô tả",
      "prop": "description"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "Mô tả"
    },
    model: {
      value: (_vm.localSetting.description),
      callback: function($$v) {
        _vm.$set(_vm.localSetting, "description", $$v)
      },
      expression: "localSetting.description"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Mô tả ngắn",
      "prop": "short_description"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Mô tả ngắn"
    },
    model: {
      value: (_vm.localSetting.short_description),
      callback: function($$v) {
        _vm.$set(_vm.localSetting, "short_description", $$v)
      },
      expression: "localSetting.short_description"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Facebook"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Facebook"
    },
    model: {
      value: (_vm.localSetting.facebook),
      callback: function($$v) {
        _vm.$set(_vm.localSetting, "facebook", $$v)
      },
      expression: "localSetting.facebook"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Googleplus"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Googleplus"
    },
    model: {
      value: (_vm.localSetting.googleplus),
      callback: function($$v) {
        _vm.$set(_vm.localSetting, "googleplus", $$v)
      },
      expression: "localSetting.googleplus"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Twitter"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Twitter"
    },
    model: {
      value: (_vm.localSetting.twitter),
      callback: function($$v) {
        _vm.$set(_vm.localSetting, "twitter", $$v)
      },
      expression: "localSetting.twitter"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Linkin"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Linkin"
    },
    model: {
      value: (_vm.localSetting.linkin),
      callback: function($$v) {
        _vm.$set(_vm.localSetting, "linkin", $$v)
      },
      expression: "localSetting.linkin"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Youtube"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Youtube"
    },
    model: {
      value: (_vm.localSetting.youtube),
      callback: function($$v) {
        _vm.$set(_vm.localSetting, "youtube", $$v)
      },
      expression: "localSetting.youtube"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Js_codes"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Js_codes"
    },
    model: {
      value: (_vm.localSetting.js_codes),
      callback: function($$v) {
        _vm.$set(_vm.localSetting, "js_codes", $$v)
      },
      expression: "localSetting.js_codes"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Email_1",
      "prop": "email_1"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Email_1"
    },
    model: {
      value: (_vm.localSetting.email_1),
      callback: function($$v) {
        _vm.$set(_vm.localSetting, "email_1", $$v)
      },
      expression: "localSetting.email_1"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Email_2",
      "prop": "email_2"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Email_2"
    },
    model: {
      value: (_vm.localSetting.email_2),
      callback: function($$v) {
        _vm.$set(_vm.localSetting, "email_2", $$v)
      },
      expression: "localSetting.email_2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Email_3",
      "prop": "email_3"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Email_3"
    },
    model: {
      value: (_vm.localSetting.email_3),
      callback: function($$v) {
        _vm.$set(_vm.localSetting, "email_3", $$v)
      },
      expression: "localSetting.email_3"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Phone_1",
      "prop": "Phone_1"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Phone_1"
    },
    model: {
      value: (_vm.localSetting.phone_1),
      callback: function($$v) {
        _vm.$set(_vm.localSetting, "phone_1", $$v)
      },
      expression: "localSetting.phone_1"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Phone_2",
      "prop": "Phone_2"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Phone_2"
    },
    model: {
      value: (_vm.localSetting.phone_2),
      callback: function($$v) {
        _vm.$set(_vm.localSetting, "phone_2", $$v)
      },
      expression: "localSetting.phone_2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Phone_3",
      "prop": "Phone_3"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Phone_3"
    },
    model: {
      value: (_vm.localSetting.phone_3),
      callback: function($$v) {
        _vm.$set(_vm.localSetting, "phone_3", $$v)
      },
      expression: "localSetting.phone_3"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Skype_1"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Skype_1"
    },
    model: {
      value: (_vm.localSetting.skype_1),
      callback: function($$v) {
        _vm.$set(_vm.localSetting, "skype_1", $$v)
      },
      expression: "localSetting.skype_1"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Skype_2"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Skype_2"
    },
    model: {
      value: (_vm.localSetting.skype_2),
      callback: function($$v) {
        _vm.$set(_vm.localSetting, "skype_2", $$v)
      },
      expression: "localSetting.skype_2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Skype_3"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Skype_3"
    },
    model: {
      value: (_vm.localSetting.skype_3),
      callback: function($$v) {
        _vm.$set(_vm.localSetting, "skype_3", $$v)
      },
      expression: "localSetting.skype_3"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Yahoo_1"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Yahoo_1"
    },
    model: {
      value: (_vm.localSetting.yahoo_1),
      callback: function($$v) {
        _vm.$set(_vm.localSetting, "yahoo_1", $$v)
      },
      expression: "localSetting.yahoo_1"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Yahoo_2"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Yahoo_2"
    },
    model: {
      value: (_vm.localSetting.yahoo_2),
      callback: function($$v) {
        _vm.$set(_vm.localSetting, "yahoo_2", $$v)
      },
      expression: "localSetting.yahoo_2"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Yahoo_3"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Yahoo_3"
    },
    model: {
      value: (_vm.localSetting.yahoo_3),
      callback: function($$v) {
        _vm.$set(_vm.localSetting, "yahoo_3", $$v)
      },
      expression: "localSetting.yahoo_3"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', [_c('button', {
    staticClass: "ui blue basic small button",
    attrs: {
      "disabled": _vm.submitting,
      "native-type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  }), _vm._v(" Lưu lại")])])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-3c30d282"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/setting/Setting.vue
// module id = 700
// module chunks = 1